import { Input } from 'apps/app/src/components/design/Input';
import type { InputProps } from 'apps/app/src/components/design/Input/Input';
import cn from 'classnames';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

export type QuantityInputProps = {
  defaultValue: number
};

const QuantityInput = forwardRef((props: InputProps<QuantityInputProps>, ref: ForwardedRef<HTMLInputElement>) => {
  return (
    <Input {...{
      ...props,
      ref,
      type: 'number',
      debounce: false,
      step: 'any',
      selectOnFocus: true,
      className: cn(
        'placeholder:text-placeholder py-3.5 w-full bg-transparent rounded text-center border-none bg-white',
      ),
    }
}
    />
  );
});

export default QuantityInput;